import { keys } from "@/lib/i18n/portal";
import type { StoreAdminStatsResponse } from "@/lib/api/types";
import { StatTile, TileGrid } from "@/shared/rd";

type Translator = (key: string) => string;

type Props = {
  stats: StoreAdminStatsResponse;
  t: Translator;
  locale?: string;
};

/** The store's five figures, as the mock's stat tiles. */
export function StoreStatsCard({ stats, t, locale }: Props) {
  const number = (value: number) => <span className="rd-num">{value.toLocaleString(locale === "ar" ? "ar-EG" : "en-US")}</span>;
  return (
    <section aria-label={t(keys.admin.storeStatsTitle)}>
      <TileGrid min={140} style={{ gap: 10 }}>
        <StatTile badge="bill" value={number(stats.orders.total)} label={t(keys.admin.storeStatsOrdersTotal)} />
        <StatTile badge="clock" value={number(stats.orders.pending)} label={t(keys.admin.storeStatsOrdersPending)} />
        <StatTile badge="delivered" value={number(stats.orders.delivered)} label={t(keys.admin.storeStatsOrdersDelivered)} />
        <StatTile badge="package" value={number(stats.catalog.products)} label={t(keys.admin.storeStatsProductsCount)} />
        <StatTile badge="folder" value={number(stats.catalog.categories)} label={t(keys.admin.storeStatsCategoriesCount)} />
      </TileGrid>
    </section>
  );
}
